import { Typography } from 'antd'
import { Campaign as CampaignModel } from '../../models/Campaign'
import { useAppSelector } from '../../utils/hooks'
import { selectCampaignById } from '../../store/CampaignReducer'

const { Text } = Typography

interface Props {
  id?: number
  model?: CampaignModel
  type?: 'full' | 'condensed'
}

export const CampaignOption = ({ id, model }: Props) => {
  const item = model ? model : useAppSelector(selectCampaignById(id!))

  if (!item) {
    return <></>
  }

  return <>{item.name}</>
}

export type CampaignOptionType = { Option: typeof CampaignOption }
